import { render, staticRenderFns } from "./menu_parcelle_listes.vue?vue&type=template&id=20952f23"
import script from "./menu_parcelle_listes.js?vue&type=script&lang=js&external"
export * from "./menu_parcelle_listes.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports